<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="limiter">
        <div class="container-login100">
            <div class="login100-more body_login">
                <div class="d-none d-lg-block d-md-block">
                    <div style="position: absolute; left: 10%; top: 30%;" class="row">
                        <div class="col-md-3 ">
                            <img style="margin-top: 5%" width="100" src="../../public/mineimages/logo_blanc_to_text.png"
                                 alt="">
                        </div>
                        <div class="col-md-9">
                            <h2 style="color: white; font-weight: bold; font-size: 55pt">SUNCARE</h2>
                        </div>
                    </div>
                    <div style="position: absolute; left: 12%; top: 45%;" class="row">
                        <p class="text-white col-md-12" style="font-weight: bold">Rassurez-vous de la disponibilité de
                            vos produits en quelques clicks</p>
                    </div>

                </div>
            </div>

            <div class="wrap-login100 ">
                <div class="" style=" padding-bottom: 2%; background-color: #096B97;">
                    <div class="row">
                        <div class="col-7">
                            <div class="p-4">
                                <h5 class="text-white" style="font-size: 16pt;font-weight:bold"> Heureux de vous revoir</h5>
                                <p class="text-white">Connectez-vous pour continuer sur Suncare.</p>
                            </div>
                        </div>
                        <div class="col-5 align-self-end">
                            <img   src="../../public/mineimages/topimg.png"  alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div class="row">
                        <div class="col-md-4">
                            <a href="#">
                                <div class="avatar-md profile-user-wid mb-4">
                                            <span class="avatar-title rounded-circle bg-light">
                                                <img src="../../public/mineimages/logo.png" alt=""
                                                     class="rounded-circle"
                                                     height="34">
                                            </span>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-8" style="position:relative;">
                            <v-text-field v-if="submittinglogin" color="primary" loading
                                          disabled style="position:absolute; top: -20%"></v-text-field>
                        </div>

                    </div>
                    <div class="p-2">


                        <form class="form-horizontal"
                              @submit.prevent="submitForm">

                            <div class="form-group">
                                 <span style="color: red" class="error-box"
                                       v-show="errorslogin!=null">{{errorslogin}}</span><br>
                                <label for="username">Adresse email</label>
                                <input type="email" v-model="email" class="form-control" id="username"
                                       placeholder="Saisissez votre email">
                                <span style="color: red" class="error-box" v-show="errors.email">{{errors.email}}</span>

                            </div>

                            <div class="form-group">
                                <label for="userpassword">Mot de passe</label>
                                <input type="password" v-model="password" class="form-control"
                                       id="userpassword"
                                       placeholder="Entrer le mot de passe">
                                <span style="color: red" class="error-box"
                                      v-show="errors.password">{{errors.password}}</span>


                            </div>

                            

                            <div class="mt-3">
                                <button :disabled="submittinglogin"  class="btn btn-block waves-effect waves-light"
                                        type="submit" style="color: white; background-color: #096B97; font-size:12pt; font-weight:bold" >
                                    <v-progress-circular v-if="submittinglogin"  indeterminate size="15"
                                                                     style="margin-right: 15px"></v-progress-circular>
                                         <span v-if="!submittinglogin"> Se connecter </span>

                                          <span v-else> Connexion en cours ... </span>
                                </button>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Login",
        data() {
            return {
                submitting: false,
                email: "",
                password: "",
                errors: {},
                state: '',
                errorslogin:null,
                isDashboard: false
            }
        }
        ,
        computed: {
            ...mapState('auth/', ['verification_errors','submittinglogin'])
        },
        mounted() {

        },
        methods: {
            initialize() {

            }
             ,
            checkisDashboard() {
                this.$emit('checkisDashboard', false);
            }
            ,
            submitForm() {

                this.submitting = true;
                this.validateForm();
                if (!this.canContinue)
                    return;
                let data = new FormData();
                data.append('email', this.email);
                data.append('password', this.password);

                this.$store.dispatch("auth/login", data).then(response => {
                    window.console.log(response.message);
                    this.submitting = false;
                    this.errorslogin = null;
                    if (response.error) {
                        this.state = 'error';
                        this.errorslogin = "Email ou mot de passe incorrecte";
                    } else {
                        window.location = window.origin
                    }
                });
            },
            validateForm() {
                this.errors = {};
                if (this.email === null || this.email.trim().length === 0) {
                    this.errors.email = "L'email est requis";
                }
                if (this.password === null || this.password.trim().length === 0) {
                    this.errors.password = "Le mot de passe est requis";
                }

                this.canContinue = Object.keys(this.errors).length === 0;
            }
            ,
            resetDatas(component) {
                Object.assign(component.$data, component.$options.data.apply(component))
            }
            ,
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

    .body_login {
        background-image: url('../../public/mineimages/backloginsuncare.jpg');
        background-repeat: repeat;
    }

</style>